export const ru = {
    error_title: 'К сожалению, сервис Яндекс Командировки пока недоступен',
    error_description: 'Мы уже в курсе проблемы и скоро все поправим',
    no_access_title: 'В данный момент у вас нет доступа к сервису',
    no_access_description: 'Обратитесь к координатору вашей компании',
};
